/* eslint-disable ember/no-mixins */
import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';
import EditPostMixin from '@linc-technologies/linced-common/mixins/edit-post';
import { action, computed } from '@ember/object';
import { isEmpty } from '@ember/utils';
import PageType from 'linced-app/enums/page-type';
import PostStatus from '@linc-technologies/linced-common/enums/post-status';
import moment from 'moment';

export default class PageController extends Controller.extend(EditPostMixin) {
  PageType = PageType;

  @computed('model.group.currentLearners.[]')
  get learners() {
    let people = this.model.group.currentLearners.map((item) => item.person);

    return people
      .slice()
      .sort(
        (a, b) =>
          (a.firstName || '').localeCompare(b.firstName || '') ||
          (a.lastName || '').localeCompare(b.lastName || ''),
      );
  }

  currentYear = moment().year();

  @tracked
  defaultPostTitle = '';

  @action
  setDefaultPostTitle(value) {
    this.defaultPostTitle = value;
  }

  @tracked
  activeAssessment = null;

  @action
  setActiveAssessment(value) {
    this.activeAssessment = value;
  }

  @tracked
  selectedPage;

  @tracked
  selectedPerson;

  @tracked postBeingEdited;

  @tracked editingPost;

  // selectedPersonIdPrefix adds the selectedPerson's id to the prefix for the new post's
  // TinyMCE editor
  @computed('selectedPerson.id')
  get selectedPersonIdPrefix() {
    if (!isEmpty(this.selectedPerson)) {
      return this.selectedPerson.get('id');
    }
    return '';
  }

  @action
  newPost(learner) {
    // Ensure that no post is selected for editing before triggering the popup.
    this.postBeingEdited = null;
    this.selectedPage = this.model.page;
    if (learner) {
      this.selectedPerson = learner;
    } else {
      this.selectedPerson = null;
    }
    this.editingPost = true;
  }

  @action
  refresh() {
    this.model.postMeta.update();
    this.resetPostParams();
  }

  @action
  closeEditPost() {
    this.resetPostParams();
  }

  @action
  getPostChips(learnerId) {
    let authors = [];
    this.model.postMeta
      .filter((item) => item.person_id === learnerId)
      .forEach((post) => {
        if (moment.unix(post.date).year() === this.currentYear) {
          let author = authors.find(
            (item) => item.authorId === post.get('author.id'),
          );
          if (isEmpty(author)) {
            authors.push({
              authorId: post.get('author.id'),
              author: post.get('author'),
              published: 0,
              unpublished: 0,
            });
            author = authors.find(
              (item) => item.authorId === post.get('author.id'),
            );
          }
          if (post.status === PostStatus.PUBLISHED) {
            author.published++;
          } else {
            author.unpublished++;
          }
        }
      });
    return authors;
  }

  resetPostParams() {
    this.selectedPerson = null;
    this.selectedPage = this.model.page;
  }
}
